import { MedicineSimple } from '@dreryk/drerykweb-medicine-api';
import { PatientMedicine } from '@dreryk/egabinet-prescription-frontend-api';
import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

import { FormLabel, StyledFlex } from '@dreryk/react-components';

import { ExtendedDosageStagesList } from '~libs.desktop.shared.medicine';
import { ExtendedDosage } from '~libs.shared.prescription';

import { prescriptionTranslationKeys } from '../../../../../translations';
import { DraftPrescriptionsFormController } from '../../draftPrescriptions/DraftPrescriptionsForm.types';
import { DraftStandardPrescriptionFieldName } from '../../draftPrescriptions/standardPrescription/DraftStandardPrescriptionField.types';

import { StyledCreateExtendedDosageLink } from './CreateExtendedDosageLink.styled';
import { ExtendedDosageModalOpener } from './ExtendedDosageModal.opener';

type ExtendedDosageStagesSummaryProps = Pick<DraftPrescriptionsFormController, 'setValue'> & {
   readonly name: DraftStandardPrescriptionFieldName;
   readonly dosageFieldName: DraftStandardPrescriptionFieldName;
   readonly dosage: string | null;
   readonly extendedDosage: ExtendedDosage;
   readonly medicine: MedicineSimple;
   readonly reimbursements: PatientMedicine['reimbursements'];
   readonly dosageFrequencyValidated: boolean;
   readonly visitDiagnoses: VisitDiagnosis[];
};

export const ExtendedDosageStagesSummary = (props: ExtendedDosageStagesSummaryProps): JSX.Element => {
   return (
      <StyledFlex direction={'column'} gap={'2px'} alignItems={'flex-start'}>
         <StyledFlex direction={'row'} alignItems={'center'} gap={'8px'}>
            <FormLabel
               testId={'extendedDosage'}
               label={prescriptionTranslationKeys.dosage.extendedDosage}
               compact
               nowrap
            />
            <ExtendedDosageModalOpener
               setValue={props.setValue}
               name={props.name}
               dosageFieldName={props.dosageFieldName}
               dosage={props.dosage}
               extendedDosage={props.extendedDosage}
               medicine={props.medicine}
               reimbursements={props.reimbursements}
               dosageFrequencyValidated={props.dosageFrequencyValidated}
               visitDiagnoses={props.visitDiagnoses}
            >
               {({ openModal }) => (
                  <StyledCreateExtendedDosageLink
                     testId={'editExtendedDosage'}
                     label={prescriptionTranslationKeys.extendedDosage.edit}
                     onClick={openModal}
                     block={false}
                  />
               )}
            </ExtendedDosageModalOpener>
         </StyledFlex>
         <ExtendedDosageStagesList
            stages={props.extendedDosage.stages}
            portionUnit={props.extendedDosage.portionUnit ?? null}
         />
      </StyledFlex>
   );
};
